import React from "react";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import MagnifyIcon from "../../../Assets/images/breach_search_magnify.svg";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const SearchBreachesHeader = () => {
    const history = useHistory();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const { register, handleSubmit, errors, clearErrors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
    });

    const onSubmit = (values: any) => {
        if (values.search) {
            history.push({
                pathname: `/breaches/search-breaches-results`,
                state: { search: values.search },
            });
        }
    };

    return (
        <React.Fragment>
            <div className="box-header padding-left-5rem">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="breach-search" />
                    </div>
                    <div className="box-title-text">
                        <h2 className="breach-section-title">{tLang("dashboard.breachIq.searchLinkText")}</h2>
                    </div>
                </div>
            </div>
            <div className="search-breach-box padding-left-5rem">
                <div className="box-description">
                    <h2 className="padding-vertical-s">{tLang("dashboard.breachIq.heading")}</h2>
                    <h3 className="padding-bottom-xl">Search the name of an organization to view listed breach details.</h3>
                </div>
                <div className="box-content">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="search-breach" className="hide-label">Enter the name of the breached organization...</label>
                        <div className="form-input input-card">
                            <input
                                type="text"
                                id="search-breach"
                                name="search"
                                className={`${
                                    !!errors["search"] && errors["search"].type === "minLength"
                                        ? "inputbox input-breach-search"
                                        : "inputbox input-breach-search margin-input-search"
                                }`}
                                placeholder="Enter the name of the breached organization..."
                                onChange={(e) => {
                                    if (e.target.value.length >= 3) {
                                        clearErrors("search");
                                    }
                                }}
                                ref={register({ required: true, minLength: 3 })}
                            />

                            {!!errors["search"] && errors["search"].type === "minLength" && (
                                <div className="margin-input-search error-breach-search">
                                    <span className="error-icon">
                                        <em className="las la-exclamation-triangle font-error"></em>
                                    </span>
                                    <span>Please enter at least three characters in search bar.</span>
                                </div>
                            )}
                            <button
                                type="submit"
                                id="btn-search-breach"
                                className="btn-default btn-search-bg-color padding-right-s search-btn-search-breach display-flex-justify-center-align-center btn-primary"
                                onClick={() => window.addToDataLayer({ event: "breachIQBtnSearch" })}
                            >
                                <img src={MagnifyIcon} alt="Magnifying Glass" />
                                <span className="btn-text btn-search-text padding-left-xs">Search</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SearchBreachesHeader;
